export default __webpack_public_path__ + "static/media/bg.94ee6f7e.svg";